import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const hours = Array.from(new Array(24), (v, i) => i);
export default function HoursColumn({ children }) {
    return (_jsx(_Fragment, { children: hours.map(hour => children({ hour })) }));
}
